import React, { useState } from 'react';
import {
  Col, Row, Card,
} from 'react-bootstrap';
import Button from 'components/DesignSystem/Button';
import useTropicoOptions from 'hooks/Meteorology/Weather/Area/Status/Tropico/useTropicoOptions';
import useTropicoStatus from 'hooks/Meteorology/Weather/Area/Status/Tropico/useTropicoStatus';
import useOlrImageDownload from 'hooks/Meteorology/Weather/Area/Status/Tropico/useOlrImageDownload';
import useVpotImageDownload from 'hooks/Meteorology/Weather/Area/Status/Tropico/useVpotImageDownload';
import CentralizedSpinner from 'components/CentralizedSpinner';
import EnlargeableImage from 'components/Meteorology/Fields/SynopticCharts/SynopticChart/Map/EnlargeableImage';
import Selector from 'components/DesignSystem/Selector';
import useIsMobile from 'utils/hooks/useIsMobile';
import StatusCard from 'components/Meteorology/Weather/Area/Status/Mobile/StatusCard';

export default function Tropico() {
  const isMobile = useIsMobile();
  const { data, isLoading: optionsLoading } = useTropicoOptions();
  const [model, setModel] = useState('');
  const [wave, setWave] = useState('');
  const { olrImageBase64, vpotImageBase64, imagesLoading } = useTropicoStatus(model, wave);
  const {
    onOlrDownloadClick,
    olrDownloadDisabled,
  } = useOlrImageDownload(
    olrImageBase64,
    imagesLoading,
    model,
    wave,
  );
  const {
    onVpotDownloadClick,
    vpotDownloadDisabled,
  } = useVpotImageDownload(
    vpotImageBase64,
    imagesLoading,
    model,
    wave,
  );

  const wavesSelector = (
    <Selector
      id="periodSelect"
      label="Ondas"
      value={wave}
      setValue={setWave}
      containerClassName={isMobile ? 'flex-grow-1' : ''}
    >
      {data?.waves.map((option) => (
        <option key={option} value={option}>{option}</option>
      ))}
    </Selector>
  );

  const modelSelector = (
    <Selector
      id="modelSelect"
      label="Modelo"
      value={model}
      setValue={setModel}
      containerClassName={isMobile ? 'flex-grow-1' : ''}
    >
      {data?.models.map((option) => (
        <option key={option} value={option}>{option}</option>
      ))}
    </Selector>
  );

  const olrDownload = (
    <Button
      id="olrImageDownloadButton"
      small
      className={`icon-button weather-download-button${isMobile ? '' : ' ms-lg-3'}`}
      onClick={onOlrDownloadClick}
      disabled={olrDownloadDisabled}
      icon="download"
    />
  );

  const vpotDownload = (
    <Button
      id="vpotImageDownloadButton"
      small
      className={`icon-button weather-download-button${isMobile ? '' : ' ms-lg-3'}`}
      onClick={onVpotDownloadClick}
      disabled={vpotDownloadDisabled}
      icon="download"
    />
  );

  if (isMobile) {
    return (
      <div className="status-stack-mobile">
        <div className="d-flex gap-2">
          {wavesSelector}
          {modelSelector}
        </div>
        <StatusCard title="ANOMALIA OLR" action={olrDownload}>
          {optionsLoading ? <CentralizedSpinner /> : (
            <>
              {imagesLoading && <CentralizedSpinner />}
              {olrImageBase64 && (
                <EnlargeableImage src={`data:image/png;base64,${olrImageBase64}`} className="mt-3" />
              )}
            </>
          )}
        </StatusCard>
        <StatusCard title="ANOMALIA VPOT" action={vpotDownload}>
          {optionsLoading ? <CentralizedSpinner /> : (
            <>
              {imagesLoading && <CentralizedSpinner />}
              {vpotImageBase64 && (
                <EnlargeableImage src={`data:image/png;base64,${vpotImageBase64}`} className="mt-3" />
              )}
            </>
          )}
        </StatusCard>
      </div>
    );
  }

  return (
    <>
      <Row className="flex-fill p-5 h-100">
        <Col>
          {wavesSelector}
        </Col>
        <Col>
          {modelSelector}
        </Col>
      </Row>
      <Row className="flex-fill px-5 h-100">
        <Col>
          <Card className="shadow-sm forecast-instruction-card h-100">
            <Card.Header className="d-flex">
              <div className="flex-fill">
                ANOMALIA OLR
              </div>
              <div className="h-100 d-flex align-items-center">
                {olrDownload}
              </div>
            </Card.Header>
            <Card.Body>
              {optionsLoading ? (
                <CentralizedSpinner />
              ) : (
                <>
                  {imagesLoading && <CentralizedSpinner />}
                  <EnlargeableImage src={`data:image/png;base64,${olrImageBase64}`} className="mt-3" />
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col xl={6} className="mt-3 mt-xl-0">
          <Card className="shadow-sm forecast-instruction-card h-100">
            <Card.Header className="d-flex">
              <div className="flex-fill">
                ANOMALIA VPOT
              </div>
              <div className="h-100 d-flex align-items-center">
                {vpotDownload}
              </div>
            </Card.Header>
            <Card.Body>
              {optionsLoading ? (
                <CentralizedSpinner />
              ) : (
                <>
                  {imagesLoading && <CentralizedSpinner />}
                  <EnlargeableImage src={`data:image/png;base64,${vpotImageBase64}`} className="mt-3" />
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
}
